<!-- Sidebar Header starts -->
<div class="sidebar-header">
    <div class="logo clearfix">
        <a [routerLink]="['/']" class="logo-text float-left" style="text-transform:initial;">
            <!-- <div class="logo-img">
                <img src="assets/img/logo.png" />
            </div> -->
            <span class="text align-middle">{{currentUser?.appName}}</span>
        </a>
        <a class="nav-toggle d-none d-sm-none d-md-none d-lg-block" id="sidebarToggle" href="javascript:;">
            <i class="ft-toggle-right toggle-icon" data-toggle="expanded"></i>
        </a>
        <a class="nav-close d-block d-md-block d-lg-none d-xl-none" id="sidebarClose" href="javascript:;">
            <i class="ft-x"></i>
        </a>
    </div>
</div>
<!-- Sidebar Header Ends -->

<!-- Sidebar Content starts -->
<div class="sidebar-content">
    <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '4px' }"></ngx-loading>
    <div class="nav-container">
        <ul class="navigation">
            <!-- First level menu -->
            <li *ngFor="let menuItem of menuItems" [ngClass]="[menuItem.class]" [routerLinkActive]="menuItem.submenu.length != 0 ? '' : 'active'"
                [routerLinkActiveOptions]="{exact: true}">
                <a [routerLink]="menuItem.class === '' ? [menuItem.path] : null" *ngIf="!menuItem.isExternalLink; else externalLinkBlock" style="white-space: nowrap;">
                    <table>
                        <tr>
                            <td style="width:40px;vertical-align:top;"><i [ngClass]="[menuItem.icon]"></i></td>
                            <td>
                                <span class="menu-title" title="{{menuItem.title | translate}}">{{menuItem.title | translate}}</span>
                                <span *ngIf="menuItem.badge != '' " [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
                            </td>
                        </tr>
                    </table>
                </a>
                <ng-template #externalLinkBlock>
                    <a [href]="[menuItem.path]" target="_blank" style="white-space: nowrap;">
                        <table>
                            <tr>
                                <td style="width:40px;vertical-align:top;"><i [ngClass]="[menuItem.icon]"></i></td>
                                <td>
                                    <span class="menu-title" title="{{menuItem.title | translate}}">{{menuItem.title | translate}}</span>
                                    <span *ngIf="menuItem.badge != '' " [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
                                </td>
                            </tr>
                        </table>
                    </a>
                </ng-template>
                <!-- Second level menu -->
                <ul class="menu-content" *ngIf="menuItem.submenu.length > 0">
                    <li *ngFor="let menuSubItem of menuItem.submenu" [routerLinkActive]="menuSubItem.submenu.length > 0 ? '' : 'active'" [ngClass]="[menuSubItem.class]">
                        <a [routerLink]="menuSubItem.submenu.length > 0 ? null : [menuSubItem.path]" *ngIf="!menuSubItem.isExternalLink; else externalSubLinkBlock" style="white-space: nowrap;">
                            <table>
                                <tr>
                                    <td style="width:40px;vertical-align:top;"><i [ngClass]="[menuSubItem.icon]"></i></td>
                                    <td>
                                        <span class="menu-title" title="{{menuSubItem.title | translate}}">{{menuSubItem.title | translate}}</span>
                                        <span *ngIf="menuSubItem.badge" [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                                    </td>
                                </tr>
                            </table>
                        </a>
                        <ng-template #externalSubLinkBlock>
                            <a [href]="[menuSubItem.path]" style="white-space: nowrap;">
                                <table>
                                    <tr>
                                        <td style="width:40px;vertical-align:top;"><i [ngClass]="[menuSubItem.icon]"></i></td>
                                        <td>
                                            <span class="menu-title" title="{{menuSubItem.title | translate}}">{{menuSubItem.title | translate}}</span>
                                            <span *ngIf="menuSubItem.badge != '' " [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                                        </td>
                                    </tr>
                                </table>
                            </a>
                        </ng-template>
                        <!-- Third level menu -->
                        <ul class="menu-content" *ngIf="menuSubItem.submenu.length > 0">
                            <li *ngFor="let menuSubsubItem of menuSubItem.submenu" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                [ngClass]="[menuSubsubItem.class]">
                                <a [routerLink]="[menuSubsubItem.path]" *ngIf="!menuSubsubItem.isExternalLink; else externalSubSubLinkBlock" style="white-space: nowrap;">
                                    <i [ngClass]="[menuSubsubItem.icon]"></i>
                                    <span class="menu-title" title="{{menuSubsubItem.title | translate}}">{{menuSubsubItem.title | translate}}</span>
                                    <span *ngIf="menuSubsubItem.badge != '' " [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                                </a>
                                <ng-template #externalSubSubLinkBlock>
                                    <a [href]="[menuSubsubItem.path]" style="white-space: nowrap;">
                                        <i [ngClass]="[menuSubsubItem.icon]"></i>
                                        <span class="menu-title" title="{{menuSubsubItem.title | translate}}">{{menuSubsubItem.title | translate}}</span>
                                        <span *ngIf="menuSubsubItem.badge != '' " [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                                    </a>
                                </ng-template>
                                <!-- Third level menu -->
                                <ul class="menu-content" *ngIf="menuSubsubItem.submenu.length > 0">
                                    <li *ngFor="let menuSubsubsubItem of menuSubsubItem.submenu" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                        [ngClass]="[menuSubsubsubItem.class]">
                                        <a [routerLink]="[menuSubsubsubItem.path]" *ngIf="!menuSubsubsubItem.isExternalLink; else externalSubSubLinkBlock" style="white-space: nowrap;">
                                            <i [ngClass]="[menuSubsubsubItem.icon]"></i>
                                            <span class="menu-title" title="{{menuSubsubsubItem.title | translate}}">{{menuSubsubsubItem.title | translate}}</span>
                                            <span *ngIf="menuSubsubsubItem.badge != '' " [ngClass]="[menuSubsubsubItem.badgeClass]">{{menuSubsubsubItem.badge}}</span>
                                        </a>
                                        <ng-template #externalSubSubLinkBlock>
                                            <a [href]="[menuSubsubsubItem.path]" style="white-space: nowrap;">
                                                <i [ngClass]="[menuSubsubsubItem.icon]"></i>
                                                <span class="menu-title" title="{{menuSubsubsubItem.title | translate}}">{{menuSubsubsubItem.title | translate}}</span>
                                                <span *ngIf="menuSubsubsubItem.badge != '' " [ngClass]="[menuSubsubsubItem.badgeClass]">{{menuSubsubsubItem.badge}}</span>
                                            </a>
                                        </ng-template>
                                        <!-- Third level menu -->
                                        <ul class="menu-content" *ngIf="menuSubsubsubItem.submenu.length > 0">
                                            <li *ngFor="let menuSubsubsubsubItem of menuSubsubsubItem.submenu" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                                [ngClass]="[menuSubsubsubsubItem.class]">
                                                <a [routerLink]="[menuSubsubsubsubItem.path]" *ngIf="!menuSubsubsubsubItem.isExternalLink; else externalSubSubLinkBlock" style="white-space: nowrap;">
                                                    <i [ngClass]="[menuSubsubsubsubItem.icon]"></i>
                                                    <span class="menu-title" title="{{menuSubsubsubsubItem.title | translate}}">{{menuSubsubsubsubItem.title | translate}}</span>
                                                    <span *ngIf="menuSubsubsubsubItem.badge != '' " [ngClass]="[menuSubsubsubsubItem.badgeClass]">{{menuSubsubsubsubItem.badge}}</span>
                                                </a>
                                                <ng-template #externalSubSubLinkBlock>
                                                    <a [href]="[menuSubsubsubsubItem.path]" style="white-space: nowrap;">
                                                        <i [ngClass]="[menuSubsubsubsubItem.icon]"></i>
                                                        <span class="menu-title" title="{{menuSubsubsubsubItem.title | translate}}">{{menuSubsubsubsubItem.title | translate}}</span>
                                                        <span *ngIf="menuSubsubsubsubItem.badge != '' " [ngClass]="[menuSubsubsubsubItem.badgeClass]">{{menuSubsubsubsubItem.badge}}</span>
                                                    </a>
                                                </ng-template>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.html